import { challengeHasTag } from "@Components/game/challenges/cards/utils";
import { getChallengeLocizeKeyPrefix } from "@Containers/game/challenges/utils";
import { getLeagueInfo } from "@Containers/shared/helpers";
import { Events } from "@Context/common/general/context";
import { ChallengeStatus } from "@Enums/index";
import useGlobalContext from "@hooks/common/general/use-global-context";
import { ChallengeResponse } from "@Shared/schemas/challenges/challengeSchemas";
import { isNumber } from "lodash-es";
import { useEffect, useState } from "react";
import useDemoAccount from "../common/user/use-demo-account";

interface IUseChallengeCardState {
  challenge: ChallengeResponse;
  disabled?: boolean;
}

interface IChallengeCardState {
  isDisabled: boolean;
  isCompleted: boolean;
  isFailed: boolean;
  noDemoAccess: boolean;
  league: string;
  division: string;
  locizeKeyPrefix: string;
  handleNavigate: () => void;
}

function useChallengeCardState({ challenge, disabled = false }: IUseChallengeCardState): IChallengeCardState {
  const { globalState } = useGlobalContext();
  const { isDemo } = useDemoAccount();
  const userRating = globalState.user.userRating || 0;
  const progressionData = globalState.user.progressionConfig as any;

  const [league, setLeague] = useState("");
  const [division, setDivision] = useState("");

  const noDemoAccess = !challengeHasTag(challenge, "DEMO") && isDemo;

  const disabledByRating =
    !!challenge.unlocked_at &&
    userRating < challenge.unlocked_at &&
    (challenge.status === ChallengeStatus.NOT_STARTED || !challenge.status);

  const isDisabled = disabledByRating || disabled || noDemoAccess;
  const isCompleted = challenge?.status === ChallengeStatus.COMPLETED;
  const isFailed = challenge?.status === ChallengeStatus.FAILED;

  const locizeKeyPrefix = getChallengeLocizeKeyPrefix(challenge);

  const handleNavigate = () => {
    Events.app.navigate.emit({ path: `/challenges/challenge/${challenge.id}` });
  };

  useEffect(() => {
    if (progressionData && isNumber(challenge.unlocked_at)) {
      const leagueInfo = getLeagueInfo(progressionData.leagues, challenge.unlocked_at);
      setLeague(leagueInfo.league?.name || "");
      setDivision(leagueInfo.division?.name || "");
    }
  }, [challenge, progressionData]);

  return {
    isDisabled,
    isCompleted,
    isFailed,
    noDemoAccess,
    league,
    division,
    locizeKeyPrefix,
    handleNavigate,
  };
}

export default useChallengeCardState;

